module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("htEJl"))).then(() => parcelRequire('fThBo'));